export const DELETION = "deletion";
export const DUPLICATION = "duplication";
export const INSERTION = "insertion";
export const TANDEM_DUP = "tandem duplication";
export const BREAKEND = "breakend";
export const INVERSION = "inversion";
export const REPEAT_EXPANSION = "repeat expansion";
